export default () => ({

    initialized: false,

    slider_top: null,

    slider_nav: null,

    autoplay: true,

    doing_autoplay_next: false,

    active_slide_index: 0,

    autoplay_progress: 0,

    has_hover: false,

    init() {

        // From swiper docs:
        // Please note, that this keyword within event handler always points to Swiper instance
        let _this = this;

        // noinspection JSUnresolvedReference
        this.slider_nav = new Swiper(this.$root.querySelector('#featured_slider_nav'), {
            slidesPerView: 1,
            spaceBetween: 20,
            freeMode: false,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 4,
                    spaceBetween: 0,
                },
            },
            on: {
                slideChange: function () {
                    // Если слайд сменился вручную
                    if (!_this.doing_autoplay_next) {
                        _this.autoplay = false;
                    }
                },
                touchStart: function () {
                    _this.autoplay_progress = 0;
                    _this.autoplay          = false;
                }
            }
        });

        // noinspection JSUnresolvedReference
        this.slider_top = new Swiper(this.$root.querySelector('#featured_slider_top'), {
            slidesPerView: 1,
            grabCursor: true,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            thumbs: {
                swiper: this.slider_nav,
            },
            on: {
                slideChange: function (swiper) {
                    _this.active_slide_index = swiper.activeIndex;
                    _this.autoplay_progress  = 0;

                    // Если слайд сменился вручную
                    if (!_this.doing_autoplay_next) {
                        _this.autoplay = false;
                    }
                },
                touchStart: function () {
                    _this.autoplay_progress = 0;
                    _this.autoplay          = false;
                }
            }
        });

        setInterval(() => {

            if (!this.autoplay || this.has_hover) {
                this.autoplay_progress = 0;
                return;
            }

            if (this.doing_autoplay_next) {
                return;
            }

            this.autoplay_progress += 0.4;

            if (this.autoplay_progress > 100) {
                this.autoplay_progress = 0;

                this.doing_autoplay_next = true;
                setTimeout(() => {
                    this.doing_autoplay_next = false;
                }, 100);

                if (this.slider_top.activeIndex === this.slider_top.slides.length - 1) {
                    this.slider_top.slideTo(0);
                } else {
                    this.slider_top.slideNext();
                }
            }
        }, 20);

        this.initialized = true;
    }
});